export default __webpack_public_path__ + "static/media/bulb.259a2e4e.svg";